<template>
    <section class="modal-card-body">
        <h4 class="has-text-centered title">Total cars selected: {{ totalCars }}</h4>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Client:</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input class="input" type="text" v-model="userName" disabled>
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Name</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input class="input" type="text" v-on:keyup="checkSubmit" v-model="groupName">
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Type</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <label class="radio">
                            <input type="radio" value="1" v-model="groupType">
                            RoRo
                        </label>
                        <label class="radio">
                            <input type="radio" value="2" v-model="groupType">
                            CONTAINER
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label"></label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <button class="button is-success" :class="{'is-loading' : isLoading}" @click="saveShippingGroup" :disabled="submitDisabled">Save changes</button>
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import apiShippingGroup from './../../../api/apiShippingGroups'
    export default {
        data() {
            return {
                submitDisabled: false,
                isLoading: false
            }
        },
        computed: {
            userName() {
                return this.$store.getters.getShippingGroupUserName
            },
            totalCars () {
                return this.$store.getters.getShippingGroupCars.length
            },
            groupType: {
                get: function () {
                    return this.$store.getters.getShippingGroupType
                },
                set: function (value) {
                    this.$store.dispatch('changeShippingGroupType', value)
                }
            },
            groupName: {
                get: function () {
                    return this.$store.getters.getShippingGroupName
                },
                set: function (value) {
                    this.$store.dispatch('changeShippingGroupName', value)
                }
            }
        },
        methods: {
            checkSubmit () {
                if (this.$store.getters.getShippingGroupName.length > 0) {
                    this.submitDisabled = false
                } else {
                    this.submitDisabled = true
                }
            },
            closeModal() {
                this.$store.dispatch('changeShippingGroupDataToDefault')
                this.$store.dispatch('changeShippingGroupModalStatus', false)
            },
            saveShippingGroup() {
                this.isLoading = true
                console.log(this.$store.getters.getShippingGroupData)
                apiShippingGroup
                    .createShippingGroupRequest(this.$store.getters.getShippingGroupData)
                    .then((response) => {
                        this.isLoading = false
                        this.$store.dispatch('fetchCars')
                        this.$store.dispatch('fetchShippingGroups', this.$route.params.id)
                        this.closeModal()
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Cars/ShippingGroup/CreateShippingGroup.vue